window.addEventListener('load', () => {
  const API_URL = 'https://us.gkhair.com';
  const REVIEWS_URL = `${API_URL}/api/reviews-summary`
  const DELAY = 2000
  
  const fetchAllReviews = async () => {
    const products = document.querySelectorAll('.gk-product-review-summary')
    
    if (!products.length) return

    const prodIds = []

    products.forEach(prod => prodIds.push(prod.id))

    try {
      const { status, reviewsAvg } = await fetch(REVIEWS_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productIds: prodIds
        })
      }).then(
        (res) => res.json()
      );

      if (status) {
        reviewsAvg.forEach(({ productId, _avg, _count }) => {
          const summaryDiv = document.getElementById(productId);
          
          if (summaryDiv) {
            const roundedRating = Math.ceil(_avg.rating);
            
            summaryDiv.innerHTML = `<p style='margin: 0;'>
              <span style='font-size: 18px; color: ${roundedRating >= 1 ? '#ffa400' : '#aaa'};'>★</span>
              <span style='font-size: 18px; color: ${roundedRating >= 2 ? '#ffa400' : '#aaa'};'>★</span>
              <span style='font-size: 18px; color: ${roundedRating >= 3 ? '#ffa400' : '#aaa'};'>★</span>
              <span style='font-size: 18px; color: ${roundedRating >= 4 ? '#ffa400' : '#aaa'};'>★</span>
              <span style='font-size: 18px; color: ${roundedRating >= 5 ? '#ffa400' : '#aaa'};'>★</span>

              <span style='margin-left: 8px;'>${_count || 0} reviews</span>
            </p>`;
          }
        })
      }
    } catch (err) {
      console.log('Error:', err.message);
    }
  };

  setTimeout(() => fetchAllReviews(), DELAY)
}) 